import Router from 'vue-router'
import Vue from 'vue'

Vue.use(Router)

const Page1Step = () => import(/* webpackChunkName: "page-1-step" */ './pages/1-step/Main')
const Page2Step = () => import(/* webpackChunkName: "page-2-step" */ './pages/2-step/Main')
const Page3Step = () => import(/* webpackChunkName: "page-3-step" */ './pages/3-step/Main')
const Page3StepPix = () => import(/* webpackChunkName: "page-3-step-pix" */ './pages/3-step/Pix')
const PagePaymentError = () => import(/* webpackChunkName: "page-payment-error" */ './pages/3-step/PaymentError.vue')
const PageSmsToken = () => import(/* webpackChunkName: "page-sms-token" */ './pages/sms-token/Main')
const PageSuccess = () => import(/* webpackChunkName: "page-success" */ './pages/Success')
const PageError = () => import(/* webpackChunkName: "page-error" */ './pages/Error')

export default new Router({
  mode: process.env.VUE_APP_MODE === 'test' ? 'history' : 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: (from) => {
        return { name: 'page-1-step', query: from.query }
      }
    },
    {
      path: '/1-step',
      name: 'page-1-step',
      component: Page1Step
    },
    {
      path: '/2-step',
      name: 'page-2-step',
      component: Page2Step
    },
    {
      path: '/3-step',
      name: 'page-3-step',
      component: Page3Step
    },
    {
      path: '/payment-error',
      name: 'page-payment-error',
      component: PagePaymentError,
      props: true
    },
    {
      path: '/3-step-pix',
      name: 'page-3-step-pix',
      component: Page3StepPix
    },
    {
      path: '/sms-token',
      name: 'page-sms-token',
      component: PageSmsToken
    },
    {
      path: '/success',
      name: 'page-success',
      component: PageSuccess,
      props: true
    },
    {
      path: '/error/:code?',
      name: 'page-error',
      component: PageError,
      props: true
    },
    {
      path: '/:televendasdata',
      name: 'page-2-step',
      component: Page2Step
    },
    {
      path: '*',
      component: PageError,
      props: { default: true, code: '404' }
    }
  ]
})
